import React from 'react';

import type { Product } from 'constants/searchTypes';
import { track } from 'apis/amethyst';
import { evRecommendationClick } from 'events/recommendations';
import { trackSponsoredAdsEvents, useSponsoredAds } from 'hooks/useSponsoredAds';
import SponsoredAdsCarousel from 'components/search/SponsoredAdsCarousel';
import { BOTTOM_PLACEMENT } from 'constants/sponsoredAds';

export interface OwnProps {
  stockId: string;
  keywords: string[];
  containerClassName: string;
  productId: string;
  isFullMaxWidth?: boolean;
}

const PdpSponsoredAds = ({ stockId, keywords, containerClassName, productId, isFullMaxWidth = false }: OwnProps): React.ReactElement => {
  const matchStylesProductId = typeof productId === 'string' ? [productId] : [];
  const sponsoredAds = useSponsoredAds({ stockId, keywords, pageType: 'Product', matchStyles: matchStylesProductId });

  const makeTrackSponsoredAdClick = (product: Pick<Product, 'productId' | 'styleId' | 'colorId'>, index: number, amazonAdsEventUrl: string) => {
    const { productId, styleId, colorId } = product;
    return () => {
      track(() => [
        evRecommendationClick,
        {
          index,
          recommendationType: 'PRODUCT_RECOMMENDATION',
          productIdentifiers: {
            productId,
            styleId,
            colorId
          },
          // NOTE: MICROSOFT values are required by Amethyst proto definition
          // See: https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto
          recommendationSource: 'MICROSOFT',
          widgetType: 'MICROSOFT_TOP_BLOCK',
          sourcePage: 'PRODUCT_PAGE'
        }
      ]);

      if (amazonAdsEventUrl) {
        trackSponsoredAdsEvents({ url: amazonAdsEventUrl, fetcherName: 'SponsoredAdsClickTracker' });
      }
    };
  };

  return (
    <SponsoredAdsCarousel
      containerClassName={containerClassName}
      sponsoredAds={sponsoredAds}
      makeSponsoredAdClick={makeTrackSponsoredAdClick}
      isFullMaxWidth={isFullMaxWidth}
      preferredResultPlacement={BOTTOM_PLACEMENT}
    />
  );
};

export default PdpSponsoredAds;
